import type {
  RouteLocationNormalized,
  RouteLocationRaw,
  RouteRecordNameGeneric,
} from 'vue-router'

import { auth } from '@/services/auth'
import { hardGateBilling20516Variant } from '@/services/ab/experiments'

/**
 * Authenticated routes a free user in the hard-gate variant can open.
 * Public routes are skipped separately via `meta.isPublicPage`.
 */
const ALLOWED_ROUTES = new Set<RouteRecordNameGeneric | null>([
  'billing',
  'billing_apple_external',
  'settings',
  'help',
  'extension_auth',
])

/**
 * Checks if conditions for the hard paywall are met: logged in, assigned treatment and hasn't started the trial yet.
 */
export function isHardGateBilling20516Active(): boolean {
  const trialStart = auth.getUser()?.trial_start
  return (
    auth.loggedIn() &&
    hardGateBilling20516Variant() === 'B' &&
    auth.isFreePlan() &&
    !trialStart
  )
}

/**
 * Where to send a gated user, or null when the route is allowed.
 */
export function hardGateBilling20516Redirect(
  to: Pick<RouteLocationNormalized, 'name' | 'query' | 'meta'>,
): RouteLocationRaw | null {
  // Public routes stay always open
  if (to.meta.isPublicPage) {
    return null
  }
  if (!isHardGateBilling20516Active()) {
    return null
  }
  if (ALLOWED_ROUTES.has(to.name)) {
    return null
  }
  return { name: 'billing', query: { ...to.query } }
}
